module.exports = __webpack_public_path__ + "img/51.counter_men.4bb0ad28.svg";